import { createSelector } from 'reselect';
import { RootState } from '../../store';

export const selectForm = createSelector(
    (state: RootState) => state.form,
    form => form,
);
